<template>
  <div>
    <Heading
      :class="[jel_getClassObject(content, { [content.type]: true }), isArchiveEmpty]"
      :contentType="content.type"
      v-html="jel_replaceTokens(getIsArchiveMode ? content.titrePromotions : content.titre)"
    ></Heading>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Heading from '@/components/base/Heading';

export default {
  name: 'TitrePromotions',
  components: { Heading },
  props: { content: { type: Object, required: true } },
  computed: {
    ...mapGetters({
      getIsArchiveMode: 'menu/getIsArchiveMode',
    }),
    isArchiveEmpty() {
      if (this.getIsArchiveMode && !this.content.titrePromotions) {
        return 'd-none';
      }
      return 'd-block';
    },
  },
};
</script>
